import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';

export const submitDemoRequest = async (payload) => {
  try {
    const submitDemoRequestFn = httpsCallable(functions, 'submitDemoRequest');
    const result = await submitDemoRequestFn(payload);
    return result.data;
  } catch (error) {
    console.error('Error enviando solicitud de demo:', error);
    throw error;
  }
};
